import JSInstances from './mutations/JSInstances';
import Reset from './mutations/Reset';
import Cart from './mutations/Cart';
import User from './mutations/User';
import UserAnalytics from './mutations/UserAnalytics';
import Wishlist from './mutations/Wishlist';
import B2B from './mutations/B2B';
import Systems from './mutations/Systems';

export default {
  ...JSInstances,
  ...Reset,
  ...Cart,
  ...User,
  ...UserAnalytics,
  ...Wishlist,
  ...B2B,
  ...Systems
};
